import { apiClient, unwrap } from '@/lib/apiClient';
import type {
  ActivityTrend,
  AdoptionTotals,
  FeatureUsageSummary,
  LoginSummary,
  TrendView,
  UsageSummary,
  UsageWindow,
} from '@/types/usage';
import type { ApiSuccess } from '@/types/api';

/** Every network call the activity feature makes (CLAUDE.md §6). */
export const activityApi = {
  /** Reports a minute of use. The server decides whether it counts. */
  heartbeat: () => unwrap(apiClient.post<ApiSuccess<null>>('/activity/heartbeat')),

  /** Time in the app across every customer — platform staff only. */
  usage: (days: UsageWindow) =>
    unwrap(apiClient.get<ApiSuccess<UsageSummary>>('/platform/usage', { params: { days } })),

  /** All-time accounts, people who have signed in, and sign-ins — platform staff only. */
  adoption: () => unwrap(apiClient.get<ApiSuccess<AdoptionTotals>>('/platform/adoption')),

  /** Logins, people and time in the app by day, month or weekday — platform staff only. */
  trend: (view: TrendView, days: 7 | 30 | 90) =>
    unwrap(apiClient.get<ApiSuccess<ActivityTrend>>('/platform/activity-trend', { params: { view, days } })),

  /** Features ranked by how many schools used them — platform staff only. */
  featureUsage: (days: UsageWindow) =>
    unwrap(apiClient.get<ApiSuccess<FeatureUsageSummary>>('/platform/feature-usage', { params: { days } })),

  /** Sign-ins across every customer, web against app — platform staff only. */
  logins: (days: UsageWindow) =>
    unwrap(apiClient.get<ApiSuccess<LoginSummary>>('/platform/logins', { params: { days } })),
};
